import styled from 'styled-components';
import THEME, { COLOR } from '../../styles/colors';

export const StyledAlert = styled.div`
  margin: auto;
  width: 100%;

  border-radius: 24px;
  background-color: ${COLOR.white};
`;

export const StyledTextWrapper = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const StyledLinksWrapper = styled.div`
  > button,
  > a {
    border-top: 1px solid ${THEME.general.border};
    border-radius: 0;
    width: 100%;
    height: 46px;
    :last-child {
      border-radius: 0 0 12px 12px;
    }
  }
`;
